var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33362 1.33341C3.33362 0.965225 3.63209 0.666748 4.00028 0.666748H12.0003C12.3685 0.666748 12.6669 0.965225 12.6669 1.33341V6.00008C12.6669 6.36827 12.3685 6.66675 12.0003 6.66675C11.6321 6.66675 11.3336 6.36827 11.3336 6.00008V2.00008H4.66695V6.00008C4.66695 6.36827 4.36847 6.66675 4.00028 6.66675C3.63209 6.66675 3.33362 6.36827 3.33362 6.00008V1.33341Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66669 6.66658C2.48988 6.66658 2.32031 6.73682 2.19528 6.86185C2.07026 6.98687 2.00002 7.15644 2.00002 7.33325V10.6666C2.00002 10.8434 2.07026 11.013 2.19528 11.138C2.32031 11.263 2.48988 11.3332 2.66669 11.3332H4.00002C4.36821 11.3332 4.66668 11.6317 4.66668 11.9999C4.66668 12.3681 4.36821 12.6666 4.00002 12.6666H2.66669C2.13625 12.6666 1.62755 12.4559 1.25247 12.0808C0.877401 11.7057 0.666687 11.197 0.666687 10.6666V7.33325C0.666687 6.80282 0.877401 6.29411 1.25247 5.91904C1.62755 5.54397 2.13625 5.33325 2.66669 5.33325H13.3333C13.8638 5.33325 14.3725 5.54397 14.7476 5.91904C15.1226 6.29411 15.3333 6.80282 15.3333 7.33325V10.6666C15.3333 11.197 15.1226 11.7057 14.7476 12.0808C14.3725 12.4559 13.8638 12.6666 13.3333 12.6666H12C11.6318 12.6666 11.3333 12.3681 11.3333 11.9999C11.3333 11.6317 11.6318 11.3332 12 11.3332H13.3333C13.5102 11.3332 13.6797 11.263 13.8047 11.138C13.9298 11.013 14 10.8434 14 10.6666V7.33325C14 7.15644 13.9298 6.98687 13.8047 6.86185C13.6797 6.73682 13.5102 6.66658 13.3333 6.66658H2.66669Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33362 9.33341C3.33362 8.96522 3.63209 8.66675 4.00028 8.66675H12.0003C12.3685 8.66675 12.6669 8.96522 12.6669 9.33341V14.6667C12.6669 15.0349 12.3685 15.3334 12.0003 15.3334H4.00028C3.63209 15.3334 3.33362 15.0349 3.33362 14.6667V9.33341ZM4.66695 10.0001V14.0001H11.3336V10.0001H4.66695Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.cc89a334c9334962d5f9dbeb976eab57.svg";
export { ForwardRef as ReactComponent };